<template>
    <CardSection :title="$t('Notes')" :enableBadge="true" :badgeValue="notes.length.toString()" :loading="loading" :expandable="false" :isExpanded="true">
        <template v-if="!readOnly" v-slot:actions>
            <IconAction :title="$t('AddNote')" :disabled="loading" @click="addNewNote">
                mdi-comment-text-outline
            </IconAction>
        </template>

        <v-data-table :headers="headers" dense :items="notes" :items-per-page="5">
            <template v-slot:[`item.createdDate`]="{ item }">
                {{ item.createdDate | formatDateGregorian }}
            </template>
            <template v-slot:[`item.actions`]="{ item }">
                <template v-if="item.canEdit">
                    <IconAction :title="$t('EditNote')" :disabled="loading" for-data-table @click="editNote(item.id, item.text)">
                        mdi-grease-pencil
                    </IconAction>
                    <IconAction :title="$t('DeleteNote')" iconColor="error" :disabled="loading" for-data-table @click="deleteNote(item.id)">
                        mdi-delete
                    </IconAction>
                </template>
            </template>
        </v-data-table>

        <CommonDialog v-if="showAddNote" v-model="showAddNote" :fullscreen="false" width="45%" :title="$t('Note')" show-action-toolbar>
            <template v-slot:actions>
                <v-btn tile color="secondary" class="white--text" small :disabled="loading" :loading="loading" @click="saveNote()">
                    {{ $t('Save') }}
                </v-btn>
                <v-btn tile color="error" small :disabled="loading" :loading="loading" @click="cancelNote()">
                    {{ $t('Cancel') }}
                </v-btn>
            </template>
            <v-container fluid>
                <v-textarea v-model="selectedNoteText"
                            outlined
                            :label="$t('Text')"
                            :rules="requiredRule"
                            class="ma-2"
                            maxlength="3900" />
            </v-container>
        </CommonDialog>
    </CardSection>
</template>
<script>
    import CardSection from '@/components/controls/CardSection.vue'
    import IconAction from '@/components/controls/IconAction.vue'
    import CommonDialog from '@/components/controls/CommonDialog.vue'

    import NotesService from '@/services/NotesService.js'

    export default {

        components: {
            CardSection,
            IconAction,
            CommonDialog
        },

        props: {

            taskId: {
                type: Number,
                default: null
            },

            readOnly: {
                type: Boolean,
                default: false
            }

        },

        data() {
            return {
                loading: false,
                showAddNote: false,
                isExpanded: false,
                selectedNoteId: null,
                selectedNoteText: null,

                notes: [],
                headers: [
                    { text: this.$t('Id'), value: 'id', align: 'start' },
                    { text: this.$t('CreatedBy'), value: 'createdBy' },
                    { text: this.$t('Text'), value: 'text' },
                    { text: this.$t('CreatedDate'), value: 'createdDate' },
                    { text: this.$t('Actions'), value: 'actions', sortable: false, width: '8%' },
                ],

                requiredRule: [(v) => !!v || this.$t('RequiredField')],
            }
        },

        created() {
            if (this.taskId != null) {
                this.listNotes()
            }
        },

        methods: {

            listNotes() {

                this.loading = true
                NotesService.listNotes(this.taskId).then((res) => {
                    this.notes = res.data
                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                }).finally(() => {
                    this.loading = false
                })
            },

            addNewNote() {
                this.selectedNoteId = null
                this.selectedNoteText = null

                this.showAddNote = true
            },

            editNote(noteId, text) {

                this.selectedNoteId = noteId
                this.selectedNoteText = text

                this.showAddNote = true
            },

            async deleteNote(noteId) {
                if (await this.$root.$confirm(this.$t('Delete'), this.$t('ConfirmDelete'))) {
                    NotesService.deleteNote(noteId)
                        .then(() => {
                            this.listNotes()
                        })
                        .catch(() => {
                            this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                        })
                }
            },

            cancelNote() {

                this.selectedNoteId = null
                this.selectedNoteText = null

                this.showAddNote = false
            },

            saveNote() {
                if (this.selectedNoteText) {

                    const note = {
                        text: this.selectedNoteText,
                        activityInstanceId: this.taskId
                    }

                    const promise = this.selectedNoteId != null && this.selectedNoteId != 0
                        ? NotesService.updateNote(this.selectedNoteId, note)
                        : NotesService.addNote(note)


                    promise.then(() => {
                        this.listNotes()
                        this.cancelNote()
                    }).catch(() => {
                        this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                    })
                }
            }

        }


    }

</script>